import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemHeading from './ItemHeading';
import ItemContent from './ItemContent';

import ItemContainer from './styles/ItemStyled';

const Item = ({ data, isToggled, selectedAccount }) => {
  const [toggled, setToggle] = useState(isToggled);
  return (
    <ItemContainer>
      <ItemHeading
        data={data}
        toggled={toggled}
        click={() => setToggle(!toggled)}
      />

      {toggled && (
        <ItemContent
          total={data?.amount}
          documentId={data?.documentId}
          dueDate={data?.dueDate}
          urlPdf={data.urlFactura}
          toggled={toggled}
          selectedAccount={selectedAccount}
        />
      )}
    </ItemContainer>
  );
};

Item.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  isToggled: PropTypes.bool.isRequired,
  selectedAccount: PropTypes.string.isRequired,
};

export default Item;
